export const trackHeadTextFuncWithSpeedFunc =
  ' \
  `${trackHead.trackNumber} ${classLookup[trackHead.trackClass]} ${(2.237 * trackHead.movement.longTermAverage.gps.magnitude).toFixed(2)} ${" mph"}`\
  ';
